import { nanoid } from "@reduxjs/toolkit"


/*
 * @props : 
        id 
        values
        labelText
        onCheckBoxChange
 */
const CheckBoxForm = (props) => {
    const id = props.id ? props.id : nanoid()
    return(
        <div className="ns-fieldset">
            <fieldset className="ns-fieldset">
                <div className=" ns-checkboxes">
                    <div className="ns-checkboxes__item">
                        <input 
                            className="ns-checkboxes__input"
                            id={id + "-input"}
                            name={id + "-input"}
                            type={"checkbox"}
                            checked={props.checked}
                            value={props.value}
                            onChange={(e) => {props.onCheckBoxChange(e.target.checked)}} />
                        <label 
                            className="ns-label ns-checkboxes__label"
                            id={id + "-label"} 
                            htmlFor={id + "-input"}>
                            <span className="ns-label-span">{props.labelText}</span>
                        </label>
                    </div>
                </div>
            </fieldset>
        </div>
    )
}

export default CheckBoxForm
